import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState()],
});
const token = localStorage.getItem("accesstoken");
if (token) {
  store.commit("LOGIN", token);
}

export default store;
